/*
 * @Autor: yingna.gao
 * @Date: 2022-08-25 15:35:45
 * @LastEditTime: 2022-08-25 15:36:16
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/components/RcBase/RcInputNumber/index.js
 */
import RcInputNumber from "./RcInputNumber";

export default RcInputNumber;
